import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_156: DocMigration = {
  maxSchemaVersion: "0.0.156",
  description: "Cleanup orphaned settings and facade labels",
  apply(json: any) {
    const settingsToDelete: string[] = [];
    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];
      const { parentId } = setting;
      const roomParent = json.rooms[parentId];
      const levelParent = json.levels[parentId];
      const setParent = json.settingsSets[parentId];
      if (!roomParent && !levelParent && !setParent) {
        settingsToDelete.push(settingsId);
      }
    }

    for (const settingId of settingsToDelete) {
      delete json.settings[settingId];
    }

    for (const roomLayoutId in json.roomLayouts) {
      const roomLayout = json.roomLayouts[roomLayoutId];

      // array of type any to avoid imporing types in migration files
      const filteredEdgeLabels: any[] = [];

      for (const edgeLabel of roomLayout.edgeLabels ?? []) {
        const facade = json.facades[edgeLabel.name];
        if (!facade) {
          continue;
        }
        filteredEdgeLabels.push(edgeLabel);
      }
      roomLayout.edgeLabels = filteredEdgeLabels;
    }

    return json;
  },
};

export default migration_0_0_156;
